import * as Sentry from "@sentry/react";
import { omit } from "ramda";

import { createLocalAxios } from "../../lib/api.js";
import apiMessages from "../../lib/apiMessages.js";

import {
  loadingSoftwarePackages,
  loadingSoftwarePackagesDone,
  setSoftwarePackages,
} from "./slice.js";

export const fetchSoftwarePackages = (params) => async (dispatch, getState) => {
  const { page, pageSize } = params || {};

  dispatch(loadingSoftwarePackages());

  const localAxios = createLocalAxios(getState);
  const url =
    page !== undefined && pageSize !== undefined
      ? `software-package/packages?page=${page}&page_size=${pageSize}`
      : "software-package/packages";

  let response;
  try {
    response = await localAxios.get(url);
  } catch (error) {
    console.error("Error while fetching the software packages:", error);
    throw error;
  } finally {
    await dispatch(loadingSoftwarePackagesDone());
  }

  await dispatch(setSoftwarePackages(response.data.softwarePackages));

  return response.data.pages;
};

export const saveSoftwarePackage =
  (values, softwarePackageId) => async (dispatch, getState) => {
    const localAxios = createLocalAxios(getState);
    const body = omit(["id", "createdAt", "updatedAt"], values);
    const url = softwarePackageId
      ? `software-package/package/${softwarePackageId}`
      : "software-package/package";

    let response;
    try {
      if (softwarePackageId) {
        response = await localAxios.patch(url, body);
      } else {
        response = await localAxios.post(url, body);
      }
    } catch (error) {
      console.error("Error while saving the software package:", error);
      Sentry.captureException(
        new Error(
          `Something went wrong: softwarePackageForm post/patch-> ${error}`,
        ),
      );
      throw error;
    }

    if (response.data.message !== apiMessages.MSG_SUCCESS) {
      throw new Error(response.data.error);
    }

    return response;
  };

export const removeSoftwarePackage = (id) => async (dispatch, getState) => {
  const localAxios = createLocalAxios(getState);
  const url = `software-package/package/${id}`;

  try {
    await localAxios.delete(url);
  } catch (error) {
    console.error(`Error deleting package: ${error}`);
    Sentry.captureException(
      new Error(`Something went wrong: removeSoftwarePackage -> ${error}`),
    );
  }
};

export const fetchSoftwarePackageById = (id) => async (dispatch, getState) => {
  const localAxios = createLocalAxios(getState);
  const url = `software-package/package/${id}`;

  let response;
  try {
    response = await localAxios.get(url);
  } catch (error) {
    console.error("Error while fetching the software package by id:", error);
    new Error(`Something went wrong: fetchSoftwarePackageById get -> ${error}`);
  }

  dispatch(setSoftwarePackages([response.data]));
  return response.data;
};
